const normalizeStates = (states) =>
    Array.from(
        new Set(
            (states || [])
                .map((state) => String(state || '').trim().toUpperCase())
                .filter((state) => /^[A-Z]{2}$/.test(state))
        )
    )

export const getEffectiveDocumentTemplateStates = (
    template,
    availableLicenseStates = []
) => {
    const templateStates = Array.isArray(template?.licenseStates)
        ? template.licenseStates
        : []
    const usesLegacyAllStates =
        Boolean(template?.allStates) || templateStates.includes('All')

    return normalizeStates(
        usesLegacyAllStates ? availableLicenseStates : templateStates
    )
}

// Pseudo-option that expands to every licensed state; never stored on templates.
export const ALL_LICENSE_STATES_OPTION_VALUE = '__ALL_LICENSE_STATES__'

export const withAllLicenseStatesOption = (options) =>
    options.length > 1
        ? [
              {
                  label: 'All license states',
                  value: ALL_LICENSE_STATES_OPTION_VALUE,
              },
              ...options,
          ]
        : options

export const resolveLicenseStateSelection = (
    selectedStates,
    availableLicenseStates = []
) =>
    (selectedStates || []).includes(ALL_LICENSE_STATES_OPTION_VALUE)
        ? [...availableLicenseStates]
        : selectedStates || []
